import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { Flex, Box, Stepper, WebviewWrapper } from '@elparking/components'
import StepOneData from '../../components/StepsIndicator/StepOneData'
import StepTwoData from '../../components/StepsIndicator/StepTwoData'
import StepThreeData from '../../components/StepsIndicator/StepThreeData'
import { Edit } from '../../components/Icons'
import { FormattedMessage, injectIntl, defineMessages } from 'react-intl'
import styled from 'styled-components'
import { RentalCarContractProcessWrapper } from 'rental-car-contract/js/ui/RentalCarContractProcess'
import BackButton from 'rental-car-contract/js/components/BackButton'

const steps = [
    {
        extraInfoComponent: <StepOneData />,
        title: <FormattedMessage defaultMessage='Introduce tus datos' />,
        stepCompletedTitle: <FormattedMessage defaultMessage='Recogida y devolución' />,
        stepMobileTitle: <FormattedMessage defaultMessage='Fechas' />,
    }, {
        extraInfoComponent: <StepTwoData />,
        title: <FormattedMessage defaultMessage='Vehículo' />,
        stepCompletedTitle: <FormattedMessage defaultMessage='Vehículo' />,
        stepMobileTitle: <FormattedMessage defaultMessage='Vehículo' />,
    }, {
        extraInfoComponent: <StepThreeData />,
        title: <FormattedMessage defaultMessage='Extras añadidos' />,
        stepMobileTitle: <FormattedMessage defaultMessage='Extras' />,
        stepCompletedTitle: <FormattedMessage defaultMessage='Extras añadidos' />,
    }, {
        title: <FormattedMessage defaultMessage='Identificación y reserva' />,
        stepMobileTitle: <FormattedMessage defaultMessage='Identificación' />,
    },
]

export const messages = defineMessages({
    step1: 'Recogida y devolución',
    step2: 'Vehículo',
    step3: 'Extras',
    step4: 'Identificación y reserva',
    step5: 'Cargando',
})

const StepperContainer = styled(Box)`
    box-shadow: 0px 5px 10px 0px rgba(0,0,0,0.05) inset;
`

const Indicator = ({ webviewWrapperComponent: WebviewWrapper, currentStep, goToStep, goToPrevStep, changeTitle, intl }) => {
    useEffect(() => {
        changeTitle(intl.formatMessage(messages[`step${currentStep}`]))
    }, [changeTitle, currentStep, intl])
    const fallbackComponent = <StepperContainer background='lightGray20' width='100%' padding='1em'>
        <RentalCarContractProcessWrapper>
            <Flex width='100%' margin='0px auto' alignItems='center'>
                <Box width='100%'>
                    <Stepper.Stepper
                      steps={steps}
                      editIcon={<Box>
                          <Box display={['none', 'inline-block']}>
                              <Edit color='gray' height='15px' />
                          </Box>
                          <Box display={['inline-block', 'none']}>
                              <Edit color='accent_dark' height='12px' />
                          </Box>
                      </Box>}
                      goToStep={({step}) => goToStep(step)}
                      currentStep={currentStep}
                      goBack={goToPrevStep} />
                </Box>
            </Flex>
        </RentalCarContractProcessWrapper>
    </StepperContainer>

    return <WebviewWrapper fallbackComponent={fallbackComponent}>
        <BackButton onClick={goToPrevStep} />
    </WebviewWrapper>
}
Indicator.propTypes = {
    currentStep: PropTypes.number,
    goToPrevStep: PropTypes.func,
    goToStep: PropTypes.func,
    changeTitle: PropTypes.func,
    intl: PropTypes.object,
    webviewWrapperComponent: PropTypes.func,
}
Indicator.defaultProps = {
    changeTitle: (title) => { document.title = title },
    webviewWrapperComponent: WebviewWrapper,
}

export default injectIntl(Indicator)
